export default {
    //登录成功跳转页
    dashboard: {
        'pd': '/stationlist',
		'pv': '/photovoltaic/dashboard',
		'hy': '/hydro/dashboard',
		'all': '/stationlist'
    },
    //dashboard点击进系统的首页
    index: {
        'pd': '/power/real/dashboard',
        'pv': '/photovoltaic/index',
        'hy': '/hydro/index',
        'all': '/system/user'
    }
}


// WEBPACK FOOTER //
// ./src/utils/module.js